import { useRef, useState } from "react";
import { Reveal } from "./Reveal";
import Logo from "./Logo";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../lib/site";
import { Instagram, Heart, MessageCircle, Send, Bookmark, Play } from "lucide-react";

const REELS = [
  { src: "/assets/reels/r1.mp4", poster: "/assets/reels/rp1.jpg", label: "Nuovo cantiere" },
  { src: "/assets/reels/r2.mp4", poster: "/assets/reels/rp2.jpg", label: "Il parquet prende vita" },
  { src: "/assets/reels/r3.mp4", poster: "/assets/reels/rp3.jpg", label: "Posa battiscopa" },
];

const IgFrame = ({ reel, index }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  const play = () => {
    const p = ref.current?.play();
    if (p) p.catch(() => {});
    setPlaying(true);
  };
  const stop = () => {
    if (ref.current) {
      ref.current.pause();
      ref.current.currentTime = 0;
    }
    setPlaying(false);
  };

  return (
    <div
      onMouseEnter={play}
      onMouseLeave={stop}
      data-testid={`ig-frame-${index}`}
      className="group w-40 shrink-0 overflow-hidden rounded-[1.8rem] border border-bark/25 bg-ink shadow-xl shadow-bark/25 transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-2xl sm:w-44 md:w-48"
    >
      <div className="flex items-center gap-2 bg-ink px-3 py-2.5">
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gradient-to-tr from-honey to-[#d62976]">
          <Instagram size={12} className="text-white" />
        </span>
        <span className="font-sans text-[10px] font-medium text-cream">
          {INSTAGRAM_HANDLE}
        </span>
        <span className="ml-auto font-sans text-[8px] uppercase tracking-widest text-sand/50">
          Reel
        </span>
      </div>
      <div className="relative aspect-[9/16]">
        <video
          ref={ref}
          poster={reel.poster}
          muted
          loop
          playsInline
          preload="metadata"
          className="h-full w-full object-cover"
          data-testid={`ig-video-${index}`}
        >
          <source src={reel.src} type="video/mp4" />
          <source src={reel.src.replace(".mp4", ".webm")} type="video/webm" />
        </video>
        {!playing && (
          <span className="absolute inset-0 flex items-center justify-center bg-ink/20 transition-opacity duration-300">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cream/90 text-ink">
              <Play size={18} className="ml-0.5 fill-ink" />
            </span>
          </span>
        )}
        <span className="absolute bottom-2 left-2 right-2 truncate rounded-full bg-ink/60 px-2.5 py-1 font-sans text-[8px] uppercase tracking-widest text-cream backdrop-blur-sm">
          {reel.label}
        </span>
      </div>
      <div className="flex items-center gap-3 bg-ink px-3 py-2.5 text-cream/80">
        <Heart size={13} />
        <MessageCircle size={13} />
        <Send size={13} />
        <Bookmark size={13} className="ml-auto" />
      </div>
    </div>
  );
};

const InstagramBand = () => (
  <section
    className="border-y border-bark/10 bg-sand/60 py-24 md:py-28"
    data-testid="instagram-section"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-12 px-5 md:px-10 lg:flex-row lg:justify-between">
      <Reveal className="max-w-md text-center lg:text-left">
        <div className="flex justify-center lg:justify-start">
          <Logo className="scale-125" />
        </div>
        <h2 className="mt-8 font-display text-3xl font-medium leading-snug text-ink sm:text-4xl">
          Ogni giorno nuovi cantieri{" "}
          <em className="text-honey">in diretta.</em>
        </h2>
        <p className="mt-3 font-sans text-sm font-light text-bark/80 md:text-base">
          Ci trovi su Instagram
        </p>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-button"
          className="mt-7 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 font-sans text-sm font-medium text-cream transition-colors duration-300 hover:bg-honey hover:text-ink"
        >
          <Instagram size={16} />
          Seguici @{INSTAGRAM_HANDLE}
        </a>
      </Reveal>

      <Reveal delay={0.15} className="flex justify-center gap-4 md:gap-5">
        {REELS.map((r, i) => (
          <IgFrame key={r.src} reel={r} index={i} />
        ))}
      </Reveal>
    </div>
  </section>
);

export default InstagramBand;
